import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation } from '@angular/core';
import { FiTaskPriorityType } from '@fi-app/task-v2/fi-task-v2-enums';
import { FiTaskV2HelperService } from '@fi-app/task-v2/fi-task-v2-helper.service';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fi-task-v2-edit-priority-simple',
    templateUrl: './fi-task-v2-edit-priority-simple.component.html',
    styleUrl: './fi-task-v2-edit-priority-simple.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-edit-priority-simple' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiTaskV2EditPrioritySimpleComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiTaskV2EditPrioritySimpleComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiTaskV2EditPrioritySimpleComponent extends ControlValueAccessorValidatorBase<FiTaskPriorityType> {
    constructor(
        injector: Injector,
        private fiTaskV2HelperService: FiTaskV2HelperService,
    ) {
        super(injector);
    }

    protected getPriorityTypeText(priorityType: FiTaskPriorityType) {
        return this.fiTaskV2HelperService.getPriorityTextByType(priorityType);
    }

    protected readonly PrioritiesList = [FiTaskPriorityType.Low, FiTaskPriorityType.Medium, FiTaskPriorityType.High];
}
